export const sliceKey = 'popularCategories';
